import { MarketType, UserInformation } from "../types";

export default function isValidMarket(
  marketParam: string | null,
  userInformation: UserInformation | null,
) {
  const isValidMarketParam =
    marketParam && ["HK", "KR", "TW", "JP"].includes(marketParam as MarketType);

  return (
    isValidMarketParam &&
    (!userInformation || userInformation.market === marketParam)
  );
}
